<div
  *ngIf="!!contactId"
  (click)="openEditSidebar($event)"
  class="contact-edit-icon"
>
  <app-icon name="pen" size="none"></app-icon>
</div>
